import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash, faPen,faBook } from '@fortawesome/free-solid-svg-icons'
library.add(faTrash, faPen,faBook)
